import { useEffect, useState } from "react";
import axios from "axios";
import bot from '../images/happy.png';
import you from '../images/boy.png';
import LoadingDots from "./LoadingDots";
import SubFeeds from "./SubFeeds";  // Ensure correct import of SubFeeds component

const Feeds = () => {
    const [feeds, setFeeds] = useState([]); // Store list of feeds
    const [selectedFeed, setSelectedFeed] = useState(null); // Store selected feed id
    const [loading, setLoading] = useState(true); // Loading state for feeds
    const [time] = useState(new Date()); // Time display

    useEffect(() => {
        axios
            .get("https://poultry-chatbot-api.onrender.com/feeds") // Get list of feeds from backend
            .then((response) => {
                if (response.data?.length > 0) {
                    setFeeds(response.data); // Set the fetched feed data
                } else {
                    alert("No Feeds found.");
                }
                setLoading(false); // Set loading to false after fetching data
            })
            .catch((error) => {
                console.error("Error fetching feeds:", error);
                alert("Failed to fetch feeds.");
                setLoading(false); // Ensure loading stops in case of error
            });
    }, []); // Empty dependency array means it runs once on initial render

    return (
        <>
            <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time.toLocaleTimeString()}
            </div>
            
            <div className="you-message">
                <div className="frame2 animated-frame">Feeds</div>
            </div>

            {loading ? (
                <div className='frame1 animated-frame'>
                    <LoadingDots />
                </div>
            ) : (
                <>
                    <div className='chatbot'>
                        <img src={bot} alt="bot" className="bot" />
                        <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>

                    <div className="frame1 animated-frame">
                        Please choose from the following options:
                        <div className="button-container" style={{textAlign: 'center'}}>
                            {feeds.map((feed) => ( // Map over the feeds and display them
                                <button
                                    key={feed.feed_id} // Unique key for each button
                                    className="Menubtns"
                                    onClick={() => setSelectedFeed(feed.feed_id)} // Set selected feed id
                                >
                                    {feed.feed_name} {/* Display feed name */}
                                </button>
                            ))}
                        </div>
                    </div>
                </>
            )}

            {selectedFeed && <SubFeeds feedId={selectedFeed} />} {/* Show sub-feeds for selected feed */}
        </>
    );
};

export default Feeds;
            